<template>
  <div>
    <open-fund-header/>
    <div class="r-text-intro">וואו</div>
    <div class="r-text-headline-paragraph">
      <div>איזה קשה זה לדאוג</div>
      <div>לעתיד ולשים כסף בצד,</div>
      <div>נכון?</div>
    </div>
    <multi-options-animated-button :options="options" />
  </div>
</template>

<script>
/* eslint-disable global-require */
import TrackedPage from '@/mixins/TrackedPage';
import MultiOptionsAnimatedButton from '@/components/base/MultiOptionsAnimatedButton';
import Segment from '@/Segment';
import OpenFundHeader from '@/components/meitav-dash/OpenFundHeader';

export default {
  name: 'Beginnings',
  components: { OpenFundHeader, MultiOptionsAnimatedButton },
  mixins: [TrackedPage],
  computed: {
    options() {
      return [
        {
          animation: JSON.stringify(require('@/assets/animations/meh-smiley-small.json')),
          label: 'לגמרי!',
          color: 'riseup-danger-dark-red',
          textColor: 'riseup-yellow',
          action: this.next,
          value: 3,
        },
        {
          animation: JSON.stringify(require('@/assets/animations/unsure-smiley-small.json')),
          label: 'ככה ככה',
          textColor: 'riseup-beige',
          color: 'riseup-danger-red',
          action: this.next,
          value: 2,
        },
        {
          animation: JSON.stringify(require('@/assets/animations/happy-smiley-small.json')),
          label: 'דווקא קל',
          color: 'riseup-pink',
          textColor: 'riseup-danger-dark-red',
          action: this.next,
          value: 1,
        },
      ];
    },
  },
  methods: {
    next(selectedOption) {
      Segment.trackUserInteraction('Saving_BeginningsSelection', { selection: selectedOption.value });
      this.$router.push('just-start');
    },
  },
};
</script>
